import { AnyAction, PayloadAction, createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';

/**
 * Формат мета-информации в экшенах {reducerPath}/executeQuery/fulfilled.
 * Экшен создается внутри RTK Query, но не экспортируется.
 */
export type QueryFulfilledAction = PayloadAction<
    unknown,
    string,
    {
        arg: {
            queryCacheKey: string;
        };
    },
    unknown
>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен резолвом запроса.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен резолвом запроса.
 */
export function createQueryFulfilledActionMatcher<Api extends AnyApi>(api: Api) {
    const queryFulfilledAction = createAction(`${api.reducerPath}/executeQuery/fulfilled`);

    return function match(action: AnyAction): action is QueryFulfilledAction {
        return queryFulfilledAction.match(action);
    };
}
